import { APIManager } from 'apiManager';
import { APIRequestConfig, FetchMethodEnum, APIRequestObj } from 'apiManager/types';

export const getAttachments = async (downloadkey: string) => {
  const requestConfig: APIRequestConfig = { method: FetchMethodEnum.GET, justResponse: true };
  const url = `/api/allegati/download?nomeFile=${downloadkey}`;
  const obj: APIRequestObj = { url, requestConfig };
  return await APIManager<Response>(obj);
};
